// Generated by ReScript, PLEASE EDIT WITH CARE

import * as InputNumberField from "./InputNumberField.res.js";

let make = InputNumberField.OptionalValue.make;

export {
  make,
}
/* InputNumberField Not a pure module */
